import React from 'react'

import noResults from '@/assets/images/no-results.png'
import { t } from '@/i18n'

const DataNotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="img">
        <img src={noResults} alt="" />
      </div>
      <div className="info">
        <h3>{t('no_result')}</h3>
        <p>
          {t('no_result_sub_title')}
          <br />
          {t('try_again')}
        </p>
      </div>
    </div>
  )
}

export default DataNotFound
